<template>
  <div class="image-uploader">
    <input v-if="!defaultFile" ref="imgInput"  type="file" @change="onFileChange" accept="image/*"/>
    <div v-if="!defaultFile"  class="image-preview">
      <img v-if="!imageUrl" :src="addImage" alt="Preview"/>
      <img :src="imageUrl" alt="">
      <div class="uploadTip" v-if="!imageUrl">{{$t('lang.workOrderReview.clickUpload')}}</div>
    </div>
    <img class="defaultFile" v-if="disabled" :src="defaultFile" alt="">
    <div class="mask" v-if="disabled">
      <div class="viewDetails" @click="setPreview">{{$t('lang.UploadProof.viewDetails')}}</div>
    </div>
    <div v-if="showPreview" class="preview-modal" @click="setPreview">
      <img class="preview"  :src="defaultFile" alt="" />
    </div>
  </div>
</template>

<script>
import addImage from '../../assets/images/workOrderReview/addImage.png'
import {Toast} from 'mint-ui'
export default {
  name: 'ImageUploader',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(vm.$ref.imgInput)
      vm.$refs.imgInput.value = ''
    })
  },
  props: ['defaultFile', 'disabled', 'bottomuse'],
  data () {
    return {
      showPreview: false,
      imageUrl: null,
      lsFile: null,
      addImage: addImage // 存储图片的URL
    }
  },
  watch: {
    defaultFile (val) {}
  },
  beforeDestroy () {
    this.$refs['imgInput'].value = ''
  },
  mounted () {},
  methods: {
    clearImgInput () {
      if (this.$refs['imgInput']) {
        this.$refs['imgInput'].value = ''
      }
      this.imageUrl = null
    },
    setPreview () {
      this.showPreview = !this.showPreview
    },
    onFileChange (event) {
      if (event.target.files.length === 0) {
        return
      }
      const file = event.target.files[0]

      // 检查上传的文件类型是否为图片
      if (!file.type.startsWith('image/')) {
        Toast(this.$t('lang.UploadProof.noUpFile'))
        this.clearImgInput() // 清空文件输入
        return // 不允许上传非图片文件
      }

      if (file) {
        this.$emit('bottomuseGetImage', file)
        if (!this.bottomuse) {
          this.$emit('getImage', file)
          this.lsFile = URL.createObjectURL(file)
          this.imageUrl = URL.createObjectURL(file) // 创建一个临时的URL来显示图片
        }
      }
    }
  }
}
</script>

<style scoped>
.defaultFile{
  height: 100%;
  width: 100%;
}
.image-uploader {
  width: 100%;
  height: 100%;
  position: relative;
}

.image-uploader input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0; /* 隐藏实际的文件输入 */
  position: absolute;
  cursor: pointer;
}

.image-preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* 保持图片的宽高比 */
}
.uploadTip{
  color: #686868;
  font-size: 2.777vw;
  font-weight: 700;
  margin-top: 1vw;
}
.mask{
  position: absolute;
  height: 110%;
  width: 100%;
  background-color: rgba(0,0,0,.7);
  top: -3vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewDetails{
  color: #02A7F0;
  font-size: 3.194vw;
  border-bottom: 1px solid;
}
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

}

.preview-modal img {
  max-width: 90%;
  max-height: 90%;
  border: 1px solid #fff;
}
preview{
  height: 200vw;
  width: 300vw;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrderReview/imageUpload.vue